import React from 'react';
import { useNavigate } from 'react-router-dom';
import WizardProgressIndicator from 'components/ui/WizardProgressIndicator';
import Icon from 'components/AppIcon';
import HeroSection from './components/HeroSection';
import BenefitsGrid from './components/BenefitsGrid';
import TestimonialsSection from './components/TestimonialsSection';
import CallToActionSection from './components/CallToActionSection';

const WelcomeCalculatorIntroduction = () => {
  const navigate = useNavigate();

  const handleStartCalculator = () => {
    navigate('/material-input-wizard');
  };

  return (
    <div className="min-h-screen md:h-screen flex flex-col">
      {/* Hide progress indicator on mobile for full screen experience */}
      <div className="hidden md:block">
        <WizardProgressIndicator />
      </div>

      <main className="flex-1 flex items-center justify-center p-4 md:p-0">
        <div className="w-full md:max-w-7xl md:mx-auto md:px-4 lg:px-8">
          {/* Call to Action Section */}
          <CallToActionSection onStartCalculator={handleStartCalculator} />
        </div>
      </main>
    </div>
  );
};

export default WelcomeCalculatorIntroduction;